import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxCurrencyModule, CurrencyMaskInputMode } from 'ngx-currency';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SharedComponentsModule } from 'src/app/shared/components/shared-components.module';
import { AdminOrderDetailModalComponent } from './modals/order-details-modal/admin-order-detail-modal.component';
import { AdminOrderEditModal } from './modals/order-edit-modal/admin-order-edit-modal.component';
import { OrderReviewModalComponent } from './modals/order-review-modal/order-review-modal.component';
import { OrderReviewReprovedModalComponent } from './modals/order-review-reproved-modal/order-review-reproved-modal.component';
import { QuotationReconciliationModalComponent } from './modals/quotation-reconciliation-modal/quotation-reconciliation-modal.component';
import { SuccessModalComponent } from './shared/modals/success-modal/success-modal.component';
import { FinancialReconciliationModalComponent } from './modals/financial-reconciliation-modal/financial-reconciliation-modal.component';
import { ReconciliationSuccessModalComponent } from './modals/reconciliation-success-modal/reconciliation-success.modal.component';
import { TableOrdersAdminComponent } from './table-orders-admin/table-orders-admin.component';
import { CustomPipeModule } from 'src/app/shared/pipes/custom-pipes.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { ApproveOrderConfirmComponent } from './modals/approve-order-confirm/approve-order-confirm.component';
import { TreasuryInfoComponent } from './modals/treasury-info/treasury-info.component';
import { ExchangeInfoComponent } from './modals/exchange-info/exchange-info.component';
import { ExchangeInfoConfirmComponent } from './modals/exchange-info-confirm/exchange-info-confirm.component';
import { PaymentConfirmComponent } from './modals/payment-confirm/payment-confirm.component';
import { SettlementInfoComponent } from './modals/settlement-info/settlement-info.component';
import { SettlementInfoConfirmComponent } from './modals/settlement-info-confirm/settlement-info-confirm.component';
import { PaymentConfirmReprovedComponent } from './modals/payment-confirm-reproved/payment-confirm-reproved.component';
import { ConfirmExteriorPaymentComponent } from './modals/confirm-exterior-payment/confirm-exterior-payment.component';
import { PaymentReprovedInboundComponent } from './modals/payment-reproved-inbound/payment-reproved-inbound.component';
import { SettlementConfirmInboundComponent } from './modals/settlement-confirm-inbound/settlement-confirm-inbound.component';
import { CreateInboundOrderComponent } from './modals/create-inbound-order/create-inbound-order.component';
import { AttachProofOperationComponent } from './modals/attach-proof-operation/attach-proof-operation.component';
import { OrderDataComponent } from './modals/order-details-modal/shared/components/order-data/order-data.component';
import { PaymentConfirmApprovedComponent } from './modals/payment-confirm-approved/payment-confirm-approved.component';
import { ExecutionOrderComponent } from './modals/execution-order/execution-order.component';
import { MassPaymentConfirmComponent } from './modals/mass-payment-confirm/mass-payment-confirm.component';
import { SendContractComponent } from './modals/send-contract/send-contract.component';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    FontAwesomeModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    SharedComponentsModule,
    HomeRoutingModule,
    MatExpansionModule,
    CustomPipeModule,
    DirectivesModule,
  ],
  declarations: [
    HomeComponent,
    TableOrdersAdminComponent,
    AdminOrderDetailModalComponent,
    ApproveOrderConfirmComponent,
    AdminOrderEditModal,
    OrderReviewModalComponent,
    TreasuryInfoComponent,
    SettlementConfirmInboundComponent,
    PaymentConfirmReprovedComponent,
    ExchangeInfoComponent,
    ExecutionOrderComponent,
    PaymentReprovedInboundComponent,
    ConfirmExteriorPaymentComponent,
    ExchangeInfoConfirmComponent,
    PaymentConfirmComponent,
    AttachProofOperationComponent,
    SettlementInfoComponent,
    CreateInboundOrderComponent,
    SettlementInfoConfirmComponent,
    SendContractComponent,
    MassPaymentConfirmComponent,
    OrderReviewReprovedModalComponent,
    QuotationReconciliationModalComponent,
    FinancialReconciliationModalComponent,
    ReconciliationSuccessModalComponent,
    SuccessModalComponent,
    OrderDataComponent,
    PaymentConfirmApprovedComponent,
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-BR',
    },
  ],
})
export class HomeModule {}
